module.exports = __webpack_public_path__ + "static/img/剪1.f1d0d70.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/剪1.png
// module id = hCaK
// module chunks = 2